module.exports = __webpack_public_path__ + "img/orange_133.4cbab0bc.png";